import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

function createRouter(routes, routerSettings) {
	const router = new VueRouter({
		routes,
		mode: 'abstract',
		base: '/'
	});

	if(routerSettings){
		router.push({
			name: routerSettings.name,
			params: {default: true, routerSettings: routerSettings}
		});
	}

	return router;
}

export default createRouter;
